module.exports = __webpack_public_path__ + "static/media/(000148).52901349.jpg";